import { useParams } from "react-router-dom";
import { BRAND_LOGO } from "../lib/brand";
import { Link } from "react-router-dom";
import { ShieldCheck } from "@phosphor-icons/react";

/**
 * Public fallback when someone scans a member QR with a generic camera app.
 * We intentionally reveal nothing about the member — only a generic message.
 */
export default function MemberQRFallback() {
  // token in URL params is intentionally unused; never decoded client-side
  useParams();
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full text-center" data-testid="qr-fallback">
        <Link to="/" className="inline-flex flex-col items-center gap-2">
          <img src={BRAND_LOGO} alt="" className="h-20 w-20 rounded-full ring-1 ring-[#D4AF37]/40" />
          <p className="font-display text-3xl text-white tracking-wide mt-4">THE SOCIAL CIRCLE</p>
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">by Cornerstone</p>
        </Link>

        <div className="mt-10 tsc-card p-7">
          <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#0d0d0d] border border-[#D4AF37]/40 text-[#D4AF37]">
            <ShieldCheck size={28} weight="duotone" />
          </div>
          <p className="font-display text-2xl text-white mt-4">Member QR</p>
          <p className="text-white/65 text-sm mt-3 leading-relaxed">
            This code can only be validated through The Social Circle partner system.
            Please present this QR to a Social Circle partner venue to validate.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <Link to="/partners" className="tsc-btn-outline" data-testid="qr-fallback-partners">Browse Partner Venues</Link>
            <Link to="/register" className="tsc-btn-gold" data-testid="qr-fallback-register">Become a Member</Link>
          </div>
        </div>

        <p className="text-white/35 text-[10px] tracking-luxe uppercase mt-8">No personal data is exposed by this code.</p>
      </div>
    </div>
  );
}
